module.exports = __webpack_public_path__ + "player-hand.4a3b711e.png";